import { useEffect } from 'react';
import { fullScreenStore, isInIframe } from '@bg-shared';
import { useStore } from '@betgames/bg-state-manager';

export const useHeight = (): void => {
    const isEnabled = useStore(fullScreenStore);

    useEffect(() => {
        const setDeviceHeight = () => {
            // "--vh" equals to 1% of screen height in pixels
            const vh = window.innerHeight * 0.01;
            document.documentElement.style.setProperty('--vh', `${vh.toFixed(3)}px`);
        };

        setDeviceHeight();

        window.addEventListener('resize', setDeviceHeight);

        return () => {
            window.removeEventListener('resize', setDeviceHeight);
        };
    }, []);

    useEffect(() => {
        if (isInIframe() && !isEnabled) {
            return undefined;
        }

        const setViewportHeight = () => {
            document.documentElement.style.setProperty(
                '--viewport-height',
                `${window.innerHeight}px`,
            );
        };

        setViewportHeight();

        window.addEventListener('resize', setViewportHeight);

        return () => {
            window.removeEventListener('resize', setViewportHeight);
        };
    }, [isEnabled]);
};
